import { Select, Tag, Spin, Typography } from "antd";
import { useAtom } from "jotai";
import { useLocation } from "react-router-dom";
import { userRolesQueryAtom } from "../../services/queries";
import { userRolesState } from "../../state";
import { useEffect, useState } from "react";
import { CheckOutlined } from "@ant-design/icons";

const { Text } = Typography;

const UserRoleSelector = ({ value, onChange }) => {
  const [roleOptions, setRoleOptions] = useState([]);
  const [selectedRole, setSelectedRole] = useState(value?.at(0).uid || null);

  const [
    {
      data: userRoles,
      isError: isUserRolesDataError,
      isLoading: isUserRolesDataLoading,
    },
  ] = useAtom(userRolesQueryAtom, { delay: 0 });

  useEffect(() => {
    if (userRoles) {
      const options = userRoles.map((opt) => ({
        label: opt.roleName,
        value: opt.uid,
        color: opt.roleName === "ROLE_ADMIN" ? "gold" : "blue",
      }));
      setRoleOptions(options);
    }
  }, [userRoles]);

  useEffect(() => {
    if (value && value.length > 0) {
      setSelectedRole(value.at(0).uid);
    }
  }, [value]);

  const handleChange = (selectedValue) => {
    setSelectedRole(selectedValue);
    const selectedRoleObj = userRoles.find(
      (role) => role.uid === selectedValue
    );
    onChange([selectedRoleObj]);
  };

  if (isUserRolesDataLoading) {
    return <Spin size="small" />;
  }

  if (!userRoles) {
    return <Text type="danger">Failed to load roles</Text>;
  }

  return (
    <Select
      value={selectedRole}
      onChange={handleChange}
      style={{ width: "100%", minWidth: "200px" }}
      placeholder="Select a role"
      optionLabelProp="label"
      filterOption={false}
      showSearch={true}
    >
      {roleOptions.map((role) => (
        <Select.Option
          key={role.value}
          value={role.value}
          label={
            <Tag color={role.color} style={{ marginRight: 8 }}>
              {role.label.split("_").pop()}
            </Tag>
          }
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {selectedRole === role.value && (
              <CheckOutlined style={{ marginRight: 8, color: "#52c41a" }} />
            )}
            <Tag color={role.color}>{role.label.split("_").pop()}</Tag>
            <Text style={{ marginLeft: 8 }}>
              {role.label.replace("ROLE_", "").toLowerCase()}
            </Text>
          </div>
        </Select.Option>
      ))}
    </Select>
  );
};

export default UserRoleSelector;
